import { MoySkladStockType } from '../server/mpsklad_core/Entity/Base/MoySkladStockType'

export const moySkladStockTypeNames: {
  readonly [K in MoySkladStockType]: string
} = {
  [MoySkladStockType.stock]: 'Физический остаток на складах, без учёта резерва и ожидания = [остаток].',
  [MoySkladStockType.freeStock]: 'Остаток на складах за вычетом резерва = [остаток] - [резерв].',
  [MoySkladStockType.quantity]: 'Доступно. Учитывает резерв и ожидания = [остаток] - [резерв] + [ожидание].'
}